import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
    DialogDescription,
    DialogFooter,
} from './ui/dialog';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { supabase } from '../lib/supabaseClient';

const WhatsAppButton = () => {
    const location = useLocation();
    const [open, setOpen] = useState(false);
    const [name, setName] = useState('');
    const [phone, setPhone] = useState('');
    const [loading, setLoading] = useState(false);

    const formatPhone = (value) => {
        // Remove all non-digits
        const numbers = value.replace(/\D/g, '');

        // Apply limit logic
        if (numbers.length > 11) return phone; // Do not allow more than 11 digits

        // Apply formatting
        // (XX) XXXXX-XXXX
        let formatted = numbers;
        if (numbers.length > 2) {
            formatted = `(${numbers.slice(0, 2)}) ${numbers.slice(2)}`;
        }
        if (numbers.length > 7) {
            formatted = `(${numbers.slice(0, 2)}) ${numbers.slice(2, 7)}-${numbers.slice(7)}`;
        }

        return formatted;
    };

    const handlePhoneChange = (e) => {
        const value = e.target.value;
        const formatted = formatPhone(value);
        setPhone(formatted);
    };

    // Only show on landing pages
    const isLandingPage = ['/', '/login', '/v1', '/v2', '/v3', '/privacy', '/terms'].includes(location.pathname);

    if (!isLandingPage) return null;

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!name || !phone) {
            alert('Por favor, preencha todos os campos.');
            return;
        }

        setLoading(true);

        try {
            const { error } = await supabase
                .from('whatsapp_leads')
                .insert([{ name, whatsapp: phone }]);

            if (error) {
                console.error('Error saving lead:', error);
                alert('Ocorreu um erro. Tente novamente.');
                setLoading(false);
                return;
            }

            // Success - Redirect
            const targetPhone = "5541992838484";
            const message = encodeURIComponent("Quero saber mais sobre o SkipLater");
            const url = `https://wa.me/${targetPhone}?text=${message}`;

            window.open(url, '_blank');
            setOpen(false);
            setName('');
            setPhone('');
        } catch (err) {
            console.error(err);
            alert('Ocorreu um erro.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <button
                onClick={() => setOpen(true)}
                className="fixed bottom-6 right-6 z-50 bg-[#25D366] hover:bg-[#128C7E] text-white p-3 rounded-full shadow-lg transition-all duration-300 hover:scale-110 flex items-center justify-center animate-in zoom-in duration-300"
                aria-label="Fale conosco no WhatsApp"
            >
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" viewBox="0 0 16 16">
                    <path d="M13.601 2.326A7.854 7.854 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.9 7.9 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.898 7.898 0 0 0 13.6 2.326zM7.994 14.521a6.573 6.573 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.557 6.557 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592zm3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.729.729 0 0 0-.529.247c-.182.198-.691.677-.691 1.654 0 .977.71 1.916.81 2.049.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232z" />
                </svg>
            </button>

            <Dialog open={open} onOpenChange={setOpen}>
                <DialogContent className="sm:max-w-[425px]">
                    <DialogHeader>
                        <DialogTitle>Fale conosco no WhatsApp</DialogTitle>
                        <DialogDescription>
                            Preencha seus dados para iniciar a conversa.
                        </DialogDescription>
                    </DialogHeader>
                    <form onSubmit={handleSubmit} className="grid gap-4 py-4">
                        <div className="grid gap-2">
                            <Label htmlFor="name">Nome</Label>
                            <Input
                                id="name"
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                placeholder="Seu nome"
                                required
                            />
                        </div>
                        <div className="grid gap-2">
                            <Label htmlFor="whatsapp">WhatsApp</Label>
                            <Input
                                id="whatsapp"
                                value={phone}
                                onChange={handlePhoneChange}
                                placeholder="(00) 00000-0000"
                                required
                            />
                        </div>
                        <DialogFooter>
                            <Button type="submit" disabled={loading} className="w-full bg-[#25D366] hover:bg-[#128C7E] text-white">
                                {loading ? 'Enviando...' : 'Iniciar Conversa'}
                            </Button>
                        </DialogFooter>
                    </form>
                </DialogContent>
            </Dialog>
        </>
    );
};

export default WhatsAppButton;
